// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .alarm-sample {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
:host .message-error {
  display: inline-block;
  /* background-color: red;; */
  color: red;
}
:host ::ng-deep .mat-tab-label {
  height: 34px !important;
  min-width: 120px !important;
}
:host .action-item {
  display: block;
  width: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  margin-top: 5px;
  margin-bottom: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/alarms/alarm-property/alarm-property.component.scss","webpack://./../../../../%E6%9D%AD%E5%B7%9E%E6%95%B0%E7%BA%B3%E5%B7%9D/IccpPlatform/fuxa/client/src/app/alarms/alarm-property/alarm-property.component.scss"],"names":[],"mappings":"AAEI;EACI,mBAAA;EACA,gBAAA;EACA,uBAAA;ACDR;ADII;EACI,qBAAA;EACA,4BAAA;EACA,UAAA;ACFR;ADKI;EACI,uBAAA;EACA,2BAAA;ACHR;ADMI;EACI,cAAA;EACA,WAAA;EACA,2CAAA;EACA,eAAA;EACA,kBAAA;ACJR","sourcesContent":[":host {\n\n    .alarm-sample {\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n\n    .message-error {\n        display: inline-block;\n        /* background-color: red;; */\n        color:red;\n    }\n\n    ::ng-deep .mat-tab-label {\n        height: 34px !important;\n        min-width: 120px !important;\n    }\n\n    .action-item {\n        display: block;\n        width: 100%;\n        border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n        margin-top: 5px;\n        margin-bottom: 5px;\n    }\n}\n",":host .alarm-sample {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n:host .message-error {\n  display: inline-block;\n  /* background-color: red;; */\n  color: red;\n}\n:host ::ng-deep .mat-tab-label {\n  height: 34px !important;\n  min-width: 120px !important;\n}\n:host .action-item {\n  display: block;\n  width: 100%;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  margin-top: 5px;\n  margin-bottom: 5px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
